import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkBox", "form"]

  connect() {
    // bootstrap-toggle requires jQuery event
    $(this.checkBoxTarget).change(this.submitForm.bind(this))
  }

  submitForm(ev) {
    ev.target.form.requestSubmit()
  }

  handleSuccess(ev) {
    this.emulateFlash(ev, "success")
  }

  handleError(ev) {
    this.emulateFlash(ev, "danger")
    this.resetToggle()
  }

  resetToggle() {
    const innerElement = $(this.checkBoxTarget).data("bs.toggle")
    if (this.checkBoxTarget.checked) {
      innerElement.off(true)
    } else {
      innerElement.on(true)
    }
  }

  emulateFlash(e, status) {
    const flashElement = document.querySelector("#alert-box > .alert")
    const closeButton = flashElement.children[0]
    flashElement.classList.remove("hidden", "alert-danger", "alert-success")
    flashElement.classList.add(`alert-${status}`)
    flashElement.innerHTML = ""
    flashElement.appendChild(closeButton)
    flashElement.append(e.detail[0].message)
  }

  hideFlash() {
    const flashElement = document.querySelector("#alert-box > .alert")
    flashElement.classList.add("hidden")
  }
}
